import { DeActiveUserIcon, PresenceBadgeIcon } from '../../modules/default-svg';
import { Avatar } from '@fluentui/react-components';
import React, { useEffect, useState, useRef } from 'react';
import CustomInput from '../../components/controls/input/customInput/CustomInput';


const AddCapacity = (props) => {
    const { item, onInputChange, onActiveChange, previousOptions } = props;
    const [isActive, setIsActive] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const inputRef = useRef(null);

    useEffect(() => {
        setIsActive(false); // Reset isActive state
        item.capacity ? setInputValue(item.capacity) : setInputValue(''); // Reset input value
        item.capacity ? setIsActive(true) : setIsActive(false); // Reset input value
    }, [item]);

    const handleContentClick = () => {
        const newIsActive = !isActive;
        setIsActive(newIsActive);
        onActiveChange(item.value, newIsActive);
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };

    const handleChange = (e) => {
        const value = e;
        item.hours = value;
        setInputValue(value);
        onInputChange(item.value, value, item.hourlyRate);
    }

    return (
        <div className="AddCapacityContent">
            <div className="d-flex align-items-center">
                <div className="d-flex flex-column me-12 justify-content-center text-center CapacityUserWrap">
                    <div className='CapacityUserActive' onClick={handleContentClick}>
                        <Avatar size={48} color="colorful" name={item.label} image={{ src: item.image }} badge={isActive ? <PresenceBadgeIcon /> : <DeActiveUserIcon />} className='CapacityUserAvatar' />
                    </div>
                    <p className='text-xsm-400 mt-1 text-nowrap text-truncate'>{item.label}</p>
                </div>
                <CustomInput type="number" inputwd="w-100" ref={inputRef} value={inputValue} handleChange={handleChange} />
            </div>
        </div>
    )
}

export default AddCapacity;